// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KCfu","col":"styles_col__1pt5h"};